import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { fetchHolidays, createHoliday } from "store/actions";
import { formatDate, displayDate } from "common/dateFormat/formatDate";
import Swal from "sweetalert2";
import { toast } from "react-hot-toast";
import Select from 'react-select';
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import dayjs from "dayjs";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Holiday = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [holidayId, setHolidayId] = useState(null);
    const [authDetails, setAuthDetails] = useState(null);
    const [isEdit, setIsEdit] = useState(false);


    const typeData = [
        { id: 1, value: "National", label: "National" },
        { id: 2, value: "International", label: "International" },
        { id: 3, value: "Festival", label: "Festival" },
        { id: 4, value: "Declared", label: "Declared Holiday" },
    ];


    const dispatch = useDispatch();

    const { holidays, loading, error, success } = useSelector((state) => state.holidayReducer || {});

    // Fetch data on component mount
    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchHolidays(unitId));
    }, [dispatch]);

    // const columns = useMemo(() => [
    //     {
    //         Header: "Action",
    //         className: "serial-no",
    //         applyHeaderClass: true,
    //         Cell: (cellProps) => {
    //             const isActive = cellProps.row.original.isActive;
    //             return (
    //                 <div className="d-flex gap-3">
    //                     <Link
    //                         to="#"
    //                         className="text-success"
    //                         onClick={() => handleEdit(cellProps.row.original)}
    //                     >
    //                         <i className="bx bxs-edit font-size-18" id="edittooltip" />
    //                         <UncontrolledTooltip placement="top" target="edittooltip">
    //                             Edit
    //                         </UncontrolledTooltip>
    //                     </Link>
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         Header: "S.No",
    //         Cell: ({ row }) => holidays.length - row.index,
    //         className: "serial-no",
    //         applyHeaderClass: true,
    //     },
    //     {
    //         Header: "Description",
    //         accessor: "Description",
    //     },
    //     {
    //         Header: "Date",
    //         accessor: "Date", // Format Date properly
    //     },
    //     {
    //         Header: "Type",
    //         accessor: "HolidayType",
    //     },
    //     {
    //         Header: "Session",
    //         accessor: "Session",
    //     },
    //     {
    //         Header: "Created By",
    //         accessor: "CreatedBy",
    //     },
    //     {
    //         Header: "Created On",
    //         accessor: "CreatedDate",

    //     },
        
    // ]);

    const columns = useMemo(() => {
        const baseColumns = [
            {
            Header: "S.No",
            Cell: ({ row }) => holidays.length - row.index,
            className: "serial-no",
            applyHeaderClass: true,
            },
            {
            Header: "Description",
            accessor: "Description",
            },
            {
            Header: "Date",
            accessor: "Date",
            },
            {
            Header: "Type",
            accessor: "HolidayType",
            },
            {
            Header: "Session",
            accessor: "Session",
            },
            {
            Header: "Created By",
            accessor: "CreatedBy",
            },
            {
            Header: "Created On",
            accessor: "CreatedDate",
            },
        ];

        // 👉 Add Action column only when canEdit is true
        if (canEdit) {
            baseColumns.unshift({
            Header: "Action",
            className: "serial-no",
            applyHeaderClass: true,
            Cell: (cellProps) => (
                <div className="d-flex gap-3">
                <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                >
                    <i className="bx bxs-edit font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                    </UncontrolledTooltip>
                </Link>
                </div>
            ),
            });
        }

        return baseColumns;

        }, [holidays, canEdit]);


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            holiday_name: holidays?.holiday_name || "",
            holiday_date: holidays?.holiday_date || "",
            holiday_type: holidays?.holiday_type || "",
            // session: holidays?.session || "",
        },
        validationSchema: Yup.object({
            holiday_name: Yup.string()
                .required("Description is required")
                .max(50, "Description must not exceed 50 characters")
                .matches(
                    /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]*$/,
                    "Only alphanumeric and special characters are allowed"
                ),
            holiday_date: Yup.date().required("Date is required"),
            holiday_type: Yup.string().required("Type is required"),
            // session: Yup.string().required("Session is required"),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Simulate form submit (API call)
                await new Promise((resolve) => setTimeout(resolve, 2000));
                const formData = new FormData();
                formData.append("holiday_name", values.holiday_name);
                formData.append("holiday_date", formatDate(values.holiday_date));
                formData.append("holiday_type", values.holiday_type);
                formData.append("created_by", authDetails.user_id);
                formData.append("unit_id", authDetails.unit_id);

                if (isEdit) {
                    formData.append("holiday_id", holidayId) // Include the stored holiday ID); // Existing holiday ID
                } else {
                    formData.append("holiday_id", 0); // New holiday
                }

                dispatch(createHoliday(formData)); // Use the same action for both create and update
                setIsEdit(false);
                formik.resetForm();
            } catch (error) {
                console.log('error > ', error)
            } finally {
                setSubmitting(false);
            }
        }
    });


    const handleEdit = (row) => {
        let formattedDate = "";

        if (row.Date) {
            // Convert "DD.MM.YYYY" or "MM/DD/YYYY" to "YYYY-MM-DD"
            const parts = row.Date.split(/[./]/); // Handles both "27.02.2025" and "03/08/2025"
            if (parts.length === 3) {
                const [day, month, year] = parts;
                formattedDate = `${year}-${month}-${day}`; // YYYY-MM-DD format
            }
        }
        setHolidayId(row.HolidayID);
        formik.setValues({
            holiday_name: row.Description,
            holiday_date: formattedDate, // Format date for input
            holiday_type: row.holiday_type_id,
            session: row.Session,
        });
        setIsEdit(true);
    };

    const handleToggleStatus = (record) => {
        const updatedStatus = !record.isActive;
        console.log(`Toggling status of ${record.description} to ${updatedStatus ? "Active" : "Inactive"}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Setup" breadcrumbItem="Holiday Master" />
                    <Row>
                        <Col lg="12">
                        {(canCreate || canEdit) && (
                            <Card>
                                <CardBody>
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Row>
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="type">
                                                        Type <span className="text-danger">*</span>
                                                    </Label>
                                                    {/* <Input
                                                        id="holiday_type"
                                                        name="holiday_type"
                                                        type="select"
                                                        value={formik.values.holiday_type}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        invalid={formik.touched.holiday_type && formik.errors.holiday_type}
                                                    >
                                                        <option value="" disabled>
                                                            Select Type
                                                        </option>
                                                        {typeData.map((type) => (
                                                            <option key={type.id} value={type.id}>
                                                                {type.label}
                                                            </option>
                                                        ))}
                                                    </Input> */}
                                                    <CustomSelect
                                                        id="holiday_type"
                                                        name="holiday_type"
                                                        options={typeData.map(type => ({ value: type.id, label: type.label }))}
                                                        value={typeData.find(type => type.id === formik.values.holiday_type)
                                                            ? { value: formik.values.holiday_type, label: typeData.find(type => type.id === formik.values.holiday_type)?.label }
                                                            : null}
                                                        onChange={val => formik.setFieldValue('holiday_type', val ? val.value : '')}
                                                        onBlur={formik.handleBlur}
                                                        className={formik.touched.holiday_type && formik.errors.holiday_type ? 'is-invalid' : ''}
                                                    />
                                                    {formik.touched.holiday_type && formik.errors.holiday_type && (
                                                        <div className="invalid-feedback">{formik.errors.holiday_type}</div>
                                                    )}
                                                    {formik.touched.holiday_type && formik.errors.holiday_type ? (
                                                        <div className="text-danger">{formik.errors.holiday_type}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="description">
                                                        Description <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        id="holiday_name"
                                                        name="holiday_name"
                                                        type="text"
                                                        maxLength={50}
                                                        value={formik.values.holiday_name}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        invalid={formik.touched.holiday_name && formik.errors.holiday_name}
                                                    />
                                                    {formik.touched.holiday_name && formik.errors.holiday_name ? (
                                                        <div className="text-danger">{formik.errors.holiday_name}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} sm={12} className="mb-3">
                                                <FormGroup>
                                                    <Label for="holiday_date">
                                                        Date <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomDatePicker
                                                        id="holiday_date"
                                                        name="holiday_date"
                                                        value={formik.values.holiday_date}
                                                        onChange={(date) => formik.setFieldValue("holiday_date", date)}
                                                        onBlur={formik.handleBlur}
                                                        className={`form-control ${formik.touched.holiday_date && formik.errors.holiday_date ? "is-invalid" : ""}`}
                                                         minDate={dayjs()}
                                                        maxDate={dayjs().endOf("year").add(1, "year")}
                                                    />
                                                    {formik.touched.holiday_date && formik.errors.holiday_date ? (
                                                        <div className="text-danger">{formik.errors.holiday_date}</div>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12} className="d-flex align-items-center justify-content-end">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className="btn button-save me-2"
                                                    disabled={formik.isSubmitting}  // Disable button while submitting
                                                >  <i className="fas fa-save me-1" />
                                                    {formik.isSubmitting ? (
                                                        <>
                                                            <Spinner size="sm" /> Processing...
                                                        </>
                                                    ) : (
                                                        isEdit ? "Update" : "Save"
                                                    )}
                                                </Button>
                                                <Button type="reset" color="secondary" onClick={() => { formik.resetForm() }} className="btn button-cancel">
                                                    <i className="fas fa-sync me-1" /> Cancel
                                                </Button>
                                            </Col>

                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        )}

                            <Card>
                                <CardBody>
                                    <TableContainer
                                        columns={columns}
                                        data={holidays && holidays.length > 0 ? holidays : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Holiday;